import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 pt-32 pb-16 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        Citi Cool Corporation respects your privacy and is committed to protecting
        your personal information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
      <p className="mb-4">
        We may collect personal information such as your name, phone number,
        email address, and message details when you submit a form on our website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Purpose of Collection</h2>
      <p className="mb-4">
        Your information is collected only to respond to enquiries, provide HVAC
        services, and communicate with you regarding your request.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Data Sharing</h2>
      <p className="mb-4">
        We do not sell, rent, or share your personal information with third parties,
        except when required by law.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Data Security</h2>
      <p className="mb-4">
        We take reasonable measures to protect your data from unauthorized access
        or disclosure.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>
      <p className="mb-4">
        You may request access, correction, or deletion of your personal data by
        contacting us using the details below.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p>
        Citi Cool Corporation <br />
        Email: admin@citicool.in <br />
        Phone: +91 77039 00307
      </p>
    </div>
  );
};

export default PrivacyPolicy;
